module.exports = __webpack_public_path__ + "static/media/responsive-design-icon.5aad1b11.svg";